import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';

// Sticky bottom bar summarizing the cart; opens the cart drawer.
// Hidden until the customer has added at least one item.
const CartBar = ({ itemCount, total, onOpen }) => {
  if (!itemCount) return null;

  return (
    <div style={styles.cartBar}>
      <span style={styles.cartSummary}>
        {itemCount}
        {' '}
        item
        {itemCount === 1 ? '' : 's'}
        {total != null && ` · $${Number(total).toFixed(2)}`}
      </span>
      <button type="button" style={styles.cartButton} onClick={onOpen}>View cart →</button>
    </div>
  );
};

CartBar.propTypes = {
  itemCount: PropTypes.number,
  total: PropTypes.number,
  onOpen: PropTypes.func.isRequired,
};

CartBar.defaultProps = {
  itemCount: 0,
  total: null,
};

export default CartBar;
